"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const DotsCircleIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  ...otherProps,
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      fill: color,
      fillRule: "nonzero",
      transform: "translate(-301 -559)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        transform: "translate(302 560)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M10.5-1C4.149-1-1 4.149-1 10.5S4.149 22 10.5 22 22 16.851 22 10.5 16.851-1 10.5-1zm0 2a9.5 9.5 0 110 19 9.5 9.5 0 010-19z"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
          cx: "10.5",
          cy: "10.5",
          r: "1.5"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
          cx: "14.799",
          cy: "10.5",
          r: "1.5"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
          cx: "6.201",
          cy: "10.5",
          r: "1.5"
        })]
      })
    })
  })]
});

DotsCircleIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = DotsCircleIcon;
exports.default = _default;